/* Ruhe: Warranty, Installation & Service Policy (draft) */
(function () {
  var root = document.querySelector('.rw');
  if (!root) return;
  var bp = (window.theme && window.theme.mediaQueries && window.theme.mediaQueries.md) || '(min-width:769px)'; /* the theme's own tablet breakpoint */
  var wide = window.matchMedia ? window.matchMedia(bp) : { matches: true };

  /* "On this page": open on desktop; one tap-to-open bar on phone that closes after a link is tapped */
  var toc = document.getElementById('rw-toc');
  if (toc) {
    var touched = false;
    var syncToc = function () { if (!touched) toc.open = wide.matches; };
    syncToc();
    if (wide.addEventListener) wide.addEventListener('change', syncToc);
    toc.querySelector('summary').addEventListener('click', function () { touched = true; });
    toc.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (a && !wide.matches) { toc.open = false; }
    });
  }

  /* Keep section headings clear of the sticky site header when jumping to a section */
  var setOffset = function () {
    var h = 0;
    document.querySelectorAll('header, [class*="header-group"], .shopify-section-group-header-group, .cc-header--sticky').forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        if (r.height <= 0) return;
        if (cs.position === 'sticky') { h = Math.max(h, Math.max(parseFloat(cs.top) || 0, 0) + r.height); }
        else if (r.top <= 1) { h = Math.max(h, r.bottom); }
      }
    });
    root.style.setProperty('--rw-offset', Math.max(Math.round(h) + 16, 72) + 'px');
  };
  setOffset();
  window.addEventListener('load', setOffset);
  window.addEventListener('resize', setOffset);

  /* Printing: open every FAQ answer, then put things back */
  var states = [];
  window.addEventListener('beforeprint', function () {
    states = [];
    root.querySelectorAll('details').forEach(function (d) { states.push([d, d.open]); d.open = true; });
  });
  window.addEventListener('afterprint', function () {
    states.forEach(function (s) { s[0].open = s[1]; });
    states = [];
  });
})();
